import {useMutation} from 'react-query';
import {postWanted} from 'services/postDetail/wanted';

const useSetWanted = (
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: postWantedPayload) => {
      return postWanted(payload);
    },
    onSuccess: (_, variables) => {
      setShowModal(false);
    },
  });

  return {isLoading, mutate};
};

export default useSetWanted;
